/* eslint-disable react/jsx-no-literals */

import { ModelConfig } from '@ant-design/graphs';
import React from 'react';

import { NodeGroup, NodeRect, NodeText } from '@security/system-overview/GraphNodeParts';

export interface ObjectNodeProps {
    cfg: ModelConfig & { detected: boolean; };
}

export const ObjectNode: React.FC<ObjectNodeProps> = ({ cfg }) => {
	const { label } = cfg ?? {};
	const height = Array.isArray(cfg.size) ? cfg.size[ 1 ] : cfg.size ?? 30;
	const width = Array.isArray(cfg.size) ? cfg.size[ 0 ] : cfg.size ?? 30;

	return (
		<NodeGroup
			capture
			draggable>
			<NodeRect
				draggable
				keyshape
				style={ {
					flexDirection: 'row',
					height: height,
					padding: 10,
					position: 'center',
					width: width
				} }>
				<NodeRect
					draggable
					style={ {
						cursor: 'pointer',
						fill: '#FFFFFF',
						flexDirection: 'row',
						justifyContent: 'center',
						radius: 2,
						stroke: '#1B96FF',
						width: 'auto'
					} }>
					<NodeRect
						draggable
						style={ {
							fill: '#1B96FF',
							height: 'auto',
							width: 4
						} } />
					<NodeRect
						draggable
						style={ {
							padding: [ 8, 6 ]
						} }>
						<NodeText
							draggable
							style={ {
								cursor: 'pointer',
								fill: 'rgba(0,0,0,0.88)',
								fontSize: 21
							} }>
							{ label as string }
						</NodeText>
					</NodeRect>
				</NodeRect>
			</NodeRect>
		</NodeGroup>
	);
};
